export default __webpack_public_path__ + "static/media/bending.84974bd2.webp";